import { gql } from "@apollo/client";
export const GET_TOP_FIVE_USERS = gql`
  query getLeaderBoardTippers {
    getLeaderBoardTippers {
      username
      currentTips
      inFanclub
      broadcaster
    }
  }
`;

export const GET_CHIPS_LEADERBOARD = gql`
  query GetChipsLeaderboard($broadcaster: String) {
    getChipsLeaderboard(broadcaster: $broadcaster) {
      username
      chips
      inFanclub
      broadcaster
    }
  }
`;

export const GET_TIPPERS = gql`
  query getTippers {
    getTippers {
      id
      username
      lifetimeTips
      lifetimeBiggestTip
      inFanclub
      discordProfile {
        id
        username
        discordTokens
      }
    }
  }
`;

export const GET_DENY_STATUS = gql`
  query getDenyStatus {
    getDenyStatus {
      deniedBy
      unDeniedBy
      isDenied
      numberOfDenies
      numberOfUndenies
    }
  }
`;

export const IS_DENY_WAR_ENABLED = gql`
  query IsDenyWarEnabled {
    isDenyWarEnabled
  }
`;

export const GET_LATEST_DENY_WAR = gql`
  query getLatestDenyWar {
    getLatestDenyWar {
      startDate
      endDate
      winAmount
      denies
      undenies
      denyLeader
      undenyLeader
      winner
    }
  }
`;

export const GET_LATEST_WON_DENY_WAR = gql`
  query getLatestWonDenyWar {
    getLatestWonDenyWar {
      startDate
      endDate
      winAmount
      denies
      undenies
      denyLeader
      undenyLeader
      winner
    }
  }
`;
export const GET_DENY_WARS = gql`
  query GetDenyWars {
    getDenyWars {
      startDate
      endDate
      winAmount
      denies
      undenies
      denyLeader
      undenyLeader
      winner
    }
  }
`;
export const GET_DENY_WAR_CONTRIBUTOR = gql`
  query getDenyWarContributors($startDate: String) {
    getDenyWarContributors(startDate: $startDate) {
      topDeniers {
        username
        count
      }
      topUndeniers {
        username
        count
      }
      progressDeniers {
        username
        count
      }
      progressUndeniers {
        username
        count
      }
      totalCounts {
        totalDenierCount
        totalUndenierCount
      }
    }
  }
`;

// GET HISTORY BY DAY
export const GET_TIP_HISTORY = gql`
  query GetTipHistory($input: GetTipHistoryInput) {
    getTipHistory(input: $input) {
      date
      tokens
    }
  }
`;

// GET DAY HISTORY
export const GET_DAY_HISTORY = gql`
  query GetTipDay($input: GetTipDayInput) {
    getTipDay(input: $input) {
      tokens
      username
    }
  }
`;

// GET TOP TIPPERS
export const GET_TOP_TIPPERS = gql`
  query GetTopTippers($range: String) {
    getTopTippers(range: $range) {
      tokens
      username
    }
  }
`;

export const GET_USER_INFO = gql`
  query getUserInfo {
    getUserInfo {
      username
      selectedMenu
      activeMenus
    }
  }
`;

export const GET_TOP_DENIERS = gql`
  query GetTopDeniers($range: String) {
    getTopDeniers(range: $range) {
      topDeniers {
        count
        username
      }
      topUndeniers {
        count
        username
      }
      totalCounts {
        totalDenierCount
        totalUndenierCount
      }
    }
  }
`;

export const GET_TOTAL_TOKENS = gql`
  query DashBoardQuery {
    getTotalTokens
  }
`;

export const GET_CUM_COUNTER = gql`
  query Query {
    getCumCounter
  }
`;
